import { isReadWaiveAsked } from '@/components/Event/NewScript/utils/errata'
import { Event } from '@/types'

type StatePolicies = {
  canHaveCna: boolean
  canWitnessReadOrWaive: boolean
  shouldConfirmStipulations: boolean
  nonDefaultClosingVerbatim: boolean
  isAK: boolean
  isAR: boolean
  isAZ: boolean
  isDE: boolean
  isDC: boolean
  isIL: boolean
  isKY: boolean
  isME: boolean
  isND: boolean
  isNE: boolean
  isNY: boolean
  isCT: boolean
  isPA: boolean
  isNV: boolean
  isMD: boolean
  isNM: boolean
  isMS: boolean
  isMT: boolean
  isRI: boolean
  isSD: boolean
  isTN: boolean
  isTX: boolean
  isUT: boolean
  isVA: boolean
  isVT: boolean
  isWV: boolean
  isWY: boolean
}

export const useStatePolicies = (event?: Event): StatePolicies => {
  if (!event?.case?.state) {
    return {
      canHaveCna: false,
      canWitnessReadOrWaive: isReadWaiveAsked(event?.errata_policy),
      shouldConfirmStipulations: false,
      nonDefaultClosingVerbatim: false,
      isAK: false,
      isAR: false,
      isAZ: false,
      isDE: false,
      isDC: false,
      isIL: false,
      isKY: false,
      isME: false,
      isND: false,
      isNE: false,
      isNY: false,
      isCT: false,
      isPA: false,
      isNV: false,
      isMD: false,
      isNM: false,
      isMS: false,
      isMT: false,
      isRI: false,
      isSD: false,
      isTN: false,
      isTX: false,
      isUT: false,
      isVA: false,
      isVT: false,
      isWV: false,
      isWY: false,
    }
  }

  return {
    canHaveCna: !['IL', 'GA'].includes(event.case.state),
    canWitnessReadOrWaive: isReadWaiveAsked(event.errata_policy),
    // Only states whose closing verbatim does NOT already ask about
    // stipulations get the standalone "Confirm stipulations" step. States in
    // `nonDefaultClosingVerbatim` (AR, MT, NM, RI, TN, WY) ask about
    // stipulations inside the "go off the record" copy, so a separate step
    // would duplicate the question (see SUP-25952).
    shouldConfirmStipulations: ['DE', 'KY', 'ND'].includes(event.case.state),
    nonDefaultClosingVerbatim: [
      'AR',
      'DC',
      'MT',
      'NM',
      'RI',
      'TN',
      'VT',
      'WV',
      'WY',
    ].includes(event.case.state),
    isAK: event.case.state === 'AK',
    isAR: event.case.state === 'AR',
    isAZ: event.case.state === 'AZ',
    isDE: event.case.state === 'DE',
    isDC: event.case.state === 'DC',
    isIL: event.case.state === 'IL',
    isKY: event.case.state === 'KY',
    isME: event.case.state === 'ME',
    isND: event.case.state === 'ND',
    isNE: event.case.state === 'NE',
    isNY: event.case.state === 'NY',
    isCT: event.case.state === 'CT',
    isPA: event.case.state === 'PA',
    isNV: event.case.state === 'NV',
    isMD: event.case.state === 'MD',
    isNM: event.case.state === 'NM',
    isMS: event.case.state === 'MS',
    isMT: event.case.state === 'MT',
    isRI: event.case.state === 'RI',
    isSD: event.case.state === 'SD',
    isTN: event.case.state === 'TN',
    isTX: event.case.state === 'TX',
    isUT: event.case.state === 'UT',
    isVA: event.case.state === 'VA',
    isVT: event.case.state === 'VT',
    isWV: event.case.state === 'WV',
    isWY: event.case.state === 'WY',
  }
}
